module.exports = __webpack_public_path__ + "img/strightLineIcon.1df96270.svg";